<div class="my-settings-only">
  <amp-site-management-preferences (closed)="closeDrawer()"></amp-site-management-preferences>
</div>
